import HTMLToPdfMake from "html-to-pdfmake";
import moment from "moment";
import CivilStatus from "@/data/enums/CivilStatus";

export const Header = image => ({
  columns: [
    {
      image,
      width: 595,
      height: 142
    }
  ]
});

export const Footer = ({ profile }) => {
  const conultant = profile.consultant;

  if (conultant) {
    const email = conultant.user ? ", " + conultant.user.email : "";
    return {
      text: `Select EXPERTS - ${conultant.firstName} ${conultant.lastName}, ${email}`,
      fontSize: 9,
      alignment: "center",
      color: "#000000"
    };
  }
};

export const Page = ({ applicant }) => ({
  pageSize: "A4",
  pageMargins: [60, 160, 60, 60],
  info: {
    title: `Export ${applicant.firstName} ${applicant.lastName}`,
    author: "Select GmbH"
  }
});

function CvEntry(entry) {
  let timeFrame = "";

  if (moment(entry.dateFrom).isValid()) {
    timeFrame = moment(entry.dateFrom).format("MM.YYYY");
  } else if (entry.dateFrom && entry.dateFrom.split("-").length === 3) {
    const parts = entry.dateFrom.split("-");
    if (+parts[1]) {
      timeFrame = `${parts[1]}.${parts[0]}`;
    } else {
      timeFrame = `${parts[0]}`;
    }
  }

  if (entry.dateUntil) {
    if (moment(entry.dateUntil).isValid()) {
      timeFrame = timeFrame + " - " + moment(entry.dateUntil).format("MM.YYYY");
    } else if (entry.dateUntil.split("-").length === 3) {
      const parts = entry.dateUntil.split("-");
      if (+parts[1]) {
        timeFrame = timeFrame + " - " + `${parts[1]}.${parts[0]}`;
      } else {
        timeFrame = timeFrame + " - " + `${parts[0]}`;
      }
    }
  } else {
    timeFrame = "seit " + timeFrame;
  }

  return {
    columns: [
      {
        width: "30%",
        text: timeFrame,
        fontSize: 12,
        lineHeight: 1.3
      },
      {
        width: "70%",
        stack: [
          // second column consists of paragraphs
          ...(entry.employer ? [{ text: entry.employer, bold: true }] : []),
          ...(entry.position ? [entry.position] : []),
          ...(entry.description ? [HTMLToPdfMake(entry.description)] : [])
        ],
        fontSize: 12,
        lineHeight: 1.3
      }
    ],
    // optional space between columns
    columnGap: 10,
    margin: [0, 0, 0, 15]
  };
}

export const Content = ({
  applicant,
  profile,
  skills,
  applicantImage,
  consultantImage
}) => {
  let content = [];
  let name = "";
  if (profile.exportName) {
    if (profile.exportNameMasking == "NUMBER") {
      name = applicant.number;
    } else if (profile.exportNameMasking == "FIRSTNAME_LASTNAME") {
      name = applicant.firstName + " " + applicant.lastName;
    } else if (profile.exportNameMasking == "SHORTFIRSTNAME_LASTNAME") {
      name = applicant.firstName.charAt(0) + ". " + applicant.lastName;
    } else if (profile.exportNameMasking == "FIRSTNAME_SHORTLASTNAME") {
      name = applicant.firstName + " " + applicant.lastName.charAt(0) + ".";
    } else if (profile.exportNameMasking == "SHORTFIRSTNAME_SHORTLASTNAME") {
      name =
        applicant.firstName.charAt(0) +
        ". " +
        applicant.lastName.charAt(0) +
        ".";
    } else if (profile.exportNameMasking == "SALUTATION_LASTNAME") {
      if (applicant.salutation == "MRS") {
        name = "Frau" + " " + applicant.lastName;
      } else if (applicant.salutation == "MR") {
        name = "Herr" + " " + applicant.lastName;
      } else {
        name = applicant.lastName;
      }
    } else if (profile.exportNameMasking == "SALUTATION_FIRSTNAME_LASTNAME") {
      if (applicant.salutation == "MRS") {
        name = "Frau" + " " + applicant.firstName + " " + applicant.lastName;
      } else if (applicant.salutation == "MR") {
        name = "Herr" + " " + applicant.firstName + " " + applicant.lastName;
      } else {
        name = applicant.firstName + " " + applicant.lastName;
      }
    } else if (
      profile.exportNameMasking == "SALUTATION_SHORTFIRSTNAME_LASTNAME"
    ) {
      if (applicant.salutation == "MRS") {
        name =
          "Frau" +
          " " +
          applicant.firstName.charAt(0) +
          ". " +
          applicant.lastName;
      } else if (applicant.salutation == "MR") {
        name =
          "Herr" +
          " " +
          applicant.firstName.charAt(0) +
          ". " +
          applicant.lastName;
      } else {
        name = applicant.firstName.charAt(0) + ". " + applicant.lastName;
      }
    } else if (profile.exportNameMasking == "SALUTATION_SHORTLASTNAME") {
      if (applicant.salutation == "MRS") {
        name = "Frau" + ". " + applicant.lastName.charAt(0) + ".";
      } else if (applicant.salutation == "MR") {
        name = "Herr" + ". " + applicant.lastName.charAt(0) + ".";
      } else {
        name = applicant.lastName.charAt(0) + ".";
      }
    } else {
      name = applicant.firstName + " " + applicant.lastName;
    }
  }

  let wantedJobTypes = "";
  profile.wantedJobTypes.forEach((element, index, array) => {
    if (index === array.length - 1) {
      wantedJobTypes = wantedJobTypes + element.name;
    } else {
      wantedJobTypes = wantedJobTypes + element.name + ", ";
    }
  });

  let driverLicenses = "";
  profile.driverLicenses.forEach((element, index, array) => {
    if (index === array.length - 1) {
      driverLicenses = driverLicenses + element.name;
    } else {
      driverLicenses = driverLicenses + element.name + ", ";
    }
  });

  let age;
  if (applicant.birthday) {
    age = "(" + moment().diff(applicant.birthday, "years", false) + ")";
  } else {
    age = "";
  }

  let personalData = {
    Name: profile.exportName ? `${name} ${age}` : null,
    Wohnort:
      applicant.contactData &&
      applicant.contactData.address &&
      profile.exportAdress
        ? `${applicant.contactData.address.city}`
        : null,
    Familienstand: applicant.civilStatus
      ? CivilStatus[applicant.civilStatus]
      : null,
    Verfügbarkeit: profile.availibilty ? profile.availibilty.name : null,
    Mobilität: profile.mobilityComment ? profile.mobilityComment : null,
    Arbeitszeit: `${wantedJobTypes}`,
    Führerschein: `${driverLicenses}`
  };

  {
    let labels = [];
    let values = [];

    for (let label of Object.keys(personalData)) {
      if (personalData[label]) {
        let value = personalData[label].label
          ? personalData[label].value
          : personalData[label];
        label = personalData[label].label ? personalData[label].label : label;

        if (value) {
          labels.push(label);
          values.push(value);
        }
      }
    }

    content.push(
      {
        text: "Persönliche Daten",
        fontSize: 15,
        bold: true,
        color: "#ad7b61",
        margin: [0, 0, 0, 15]
      },
      profile.wantedOccupation
        ? {
            columns: [
              {
                width: "25%",
                text: "Qualifikation:",
                margin: [0, 20, 0, 20],
                bold: true,
                fontSize: 12,
                lineHeight: 1.3
              },
              {
                width: "75%",
                text: profile.wantedOccupation
                  ? profile.wantedOccupation
                  : null,
                margin: [0, 20, 0, 20],
                bold: true,
                fontSize: 12,
                lineHeight: 1.3
              }
            ],
            // optional space between columns
            columnGap: 10,
            margin: [0, 0, 0, 10]
          }
        : null,
      {
        columns: [
          {
            width: "25%",
            stack: labels,
            fontSize: 12,
            lineHeight: 1.3
          },
          {
            width: "55%",
            stack: values,
            fontSize: 12,
            lineHeight: 1.3
          },
          ...(applicantImage && profile.showPicture
            ? [
                {
                  image: applicantImage,
                  width: 100
                }
              ]
            : [])
        ],
        // optional space between columns
        columnGap: 10,
        margin: [0, 0, 0, 40]
      }
    );
  }

  if (profile.shortProfileDescription && profile.exportShortDescription) {
    content.push({
      text: "Kurzprofil",
      fontSize: 15,
      bold: true,
      color: "#ad7b61",
      margin: [0, 0, 0, 15]
    });

    content.push(HTMLToPdfMake(profile.shortProfileDescription));
    content.push({ text: "", margin: [0, 0, 0, 30] });
  }
  if (profile.internalRatingComment && profile.exportInternalRating) {
    content.push({
      text: "Bewertung",
      fontSize: 15,
      bold: true,
      color: "#ad7b61",
      margin: [0, 0, 0, 15]
    });

    content.push(HTMLToPdfMake(profile.internalRatingComment));
    content.push({ text: "", margin: [0, 0, 0, 30] });
  }

  if (profile.cvEntries.length) {
    let sortedCategories = {};

    for (let entry of profile.cvEntries) {
      if (!sortedCategories[entry.type.id]) {
        sortedCategories[entry.type.id] = [];
      }

      sortedCategories[entry.type.id].push(entry);
    }

    for (const entries of Object.values(sortedCategories).sort((a, b) => {
      if (a[0].type.name === "Berufserfahrung") {
        return -1;
      } else if (b[0].type.name === "Berufserfahrung") {
        return 1;
      }
      return 0;
    })) {
      content.push({
        text: entries[0].type.name,
        fontSize: 15,
        bold: true,
        color: "#ad7b61",
        margin: [0, 0, 0, 15]
      });

      for (let entry of entries) {
        content.push(CvEntry(entry));
      }
    }
  }

  if (skills) {
    for (const entry of skills) {
      const skillValues = entry.group.skillValues;
      const shouldBeSkipped = !entry.categories.some(cat =>
        cat.skills.some(skill => skill.inputType !== "BOOLEAN" || skill.value)
      );
      if (shouldBeSkipped) {
        continue;
      }

      content.push({
        text: entry.group.name,
        fontSize: 15,
        bold: true,
        color: "#ad7b61",
        margin: [0, 0, 0, 15]
      });

      for (let cat of entry.categories) {
        const shouldBeSkipped = !cat.skills.some(
          skill => skill.inputType !== "BOOLEAN" || skill.value
        );
        if (shouldBeSkipped) {
          continue;
        }
        content.push({
          text: cat.name,
          bold: true,
          fontSize: 12,
          margin: [0, 0, 0, 5]
        });

        let labels = [];
        let values = [];
        for (let skill of cat.skills) {
          if (skill.inputType === "BOOLEAN" && skill.value) {
            labels.push(skill.name);
            values.push(skill.value ? "Ja" : "Nein");
          } else if (
            skill.inputType !== "BOOLEAN" &&
            skillValues[skill.value]
          ) {
            labels.push(skill.name);
            values.push(skillValues[skill.value].name);
          }
        }

        content.push({
          columns: [
            {
              width: "75%",
              stack: labels,
              fontSize: 12,
              lineHeight: 1.3
            },
            {
              width: "25%",
              stack: values,
              fontSize: 12,
              lineHeight: 1.3
            }
          ],
          // optional space between columns
          columnGap: 10,
          margin: [0, 0, 0, 15],
          unbreakable: true
        });
      }
    }
  }

  content.push(
    {
      text:
        "Wir tun unser Bestes, Kandidaten und Unternehmen schnell und für alle Beteiligten erfolgreich zusammen zu bringen. Falls Sie Interesse an diesem Kandidaten haben, zögern Sie nicht lange: Die meisten unserer Kandidaten sind derzeit nach 24 Stunden bereits vergeben und im Einsatz bei einem unserer Mandanten.",
      fontSize: 12,
      lineHeight: 1.3,
      margin: [0, 30, 0, 0],
      unbreakable: true
    },
    {
      text:
        "Gerne werden wir für Sie aktiv: Wenn Sie diesen Kandidaten kennen lernen möchten, nehmen Sie Kontakt mit uns auf:",
      fontSize: 12,
      lineHeight: 1.3,
      margin: [0, 15, 0, 0],
      unbreakable: true
    }
  );

  if (profile.consultant) {
    const consultant = profile.consultant;
    let department = "";

    if (consultant.department) {
      department = `, Niederlassung ${consultant.department.name}`;
    }

    content.push({
      columns: [
        {
          width: "70%",
          stack: [
            // second column consists of paragraphs
            {
              text: "Ihr Ansprechpartner",
              bold: true,
              decoration: "underline",
              margin: [0, 0, 0, 15]
            },
            {
              text: `${consultant.firstName} ${consultant.lastName}${department}`,
              margin: [0, 0, 0, 15]
            },
            "Select GmbH",
            // "Im Rollfeld 38",
            // "76532 Baden-Baden",
            `Telefon: ${consultant.telephone || "-"}`,
            consultant.fax ? `Fax: ${consultant.fax || "-"}` : null,
            `E-Mail: ${consultant.user ? consultant.user.email : "-"}`
          ],
          fontSize: 12,
          lineHeight: 1.3
        },
        ...(consultantImage
          ? [
              {
                image: consultantImage,
                width: 100
              }
            ]
          : [])
      ],
      // optional space between columns
      columnGap: 10,
      margin: [0, 15, 0, 15],
      unbreakable: true
    });
  }

  if (profile.commissionAmount) {
    content.push(
      {
        text: "Vermittlung",
        fontSize: 12,
        lineHeight: 1.3,
        bold: true,
        decoration: "underline",
        margin: [0, 30, 0, 0]
      },
      {
        text: `Ein Arbeitsverhältnis, welches der Kunde mit einem von Select vorgestellten Kandidaten eingeht, gilt als provisionspflichtige Vermittlung. In diesem Fall beträgt die Vermittlungsprovision ${profile.commissionAmount} Prozent der zwischen Kunde und Kandidat vereinbarten Bruttojahresvergütung zzgl. Mehrwertsteuer.`,
        fontSize: 12,
        lineHeight: 1.3,
        margin: [0, 15, 0, 0],
        unbreakable: true
      }
    );
  }

  return content;
};
